import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/salesData';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-16 px-4 bg-white" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-88">
          <h2 className="text-3xl md:text-4xl font-bold text-primary" data-id="element-89">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-90">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="border border-gray-200 rounded-lg overflow-hidden bg-surface-light" data-id="element-91">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white transition-colors" data-id="element-92">
                <span className="font-semibold text-gray-900 pr-4" data-id="element-93">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-gray-500 flex-shrink-0 transition-transform ${openIndex === index ? 'transform rotate-180' : ''}`} data-id="element-94" />
              </button>

              <AnimatePresence data-id="element-95">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden bg-white" data-id="element-96">
                    <div className="p-6 pt-4 text-gray-700 border-t border-gray-100" data-id="element-97">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}